export default __webpack_public_path__ + "static/media/close.4b11b721.svg";